import { render } from "./DS100AddressIdSelection.vue?vue&type=template&id=6d8455ef&scoped=true"
import script from "./DS100AddressIdSelection.vue?vue&type=script&lang=js"
export * from "./DS100AddressIdSelection.vue?vue&type=script&lang=js"

import "./DS100AddressIdSelection.vue?vue&type=style&index=0&id=6d8455ef&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8455ef"]])

export default __exports__